






















import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import { Recurso } from '@/__env/lib/Cursos/Recursos';
import { Wait } from '@/__env/ext';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
import { Curso } from '@/__env/lib/Cursos';
import { isNumber, isArray } from 'util';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
@Component( {
    name: "Componente",
    props: {},
    components: {

    }
} )
export default class Componente extends Vue
{
    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }
    public get Resultado(): Resultado { return Model.Resultado; }

    public Intervalo: NodeJS.Timeout = null;
    public Finalizado: boolean = false;
    public Progreso: number = 0;
    @Watch( 'Progreso' )
    async onCalificacion()
    {
        if ( this.Resultado && this.Progreso == this.Resultado.Progreso.round( 0 ) )
        {
            this.Finalizado = true;
            clearInterval( this.Intervalo );
        }
    }

    async mounted()
    {

        this.Intervalo = setInterval( () =>
        {
            this.Progreso++;
        }, this.Resultado.Progreso > 30 ? 100 : 300 );
    }
}
